import ParsedDecoratorChildren from "../components/ParsedDecoratorChildren";
import { REGEX_BIU } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var BoldItalicUnderline = function BoldItalicUnderline(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  var text = decoratedText.match(REGEX_BIU) ? decoratedText.substring(2, decoratedText.length - 2) : decoratedText;
  return /*#__PURE__*/_jsx("strong", {
    className: "italic tw-font-semibold underline",
    "data-offset-key": offsetKey,
    children: /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
      text: text,
      isDark: isDark
    })
  });
};
export default BoldItalicUnderline;